<template>
  <el-dialog title="Добавление типа клиента" :visible.sync="isOpen" width="30%">
    <el-form
      v-if="clientType"
      ref="formСreateRef"
      :model="clientType"
      :rules="rules"
      label-width="100px"
      label-position="top"
    >
      <el-form-item label="Название" prop="title">
        <el-input v-model="clientType.title" />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="isOpen = false">Закрыть</el-button>
      <el-button type="primary" @click="saveClientType">Сохранить</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { useClientTypeCreate } from './useClientTypeCreate';

export default {
  name: 'ClientTypeCreate',
  setup() {
    const { isOpen, open, clientType, saveClientType, rules, formСreateRef } =
      useClientTypeCreate();

    return {
      isOpen,
      open,
      clientType,
      saveClientType,
      rules,
      formСreateRef,
    };
  },
};
</script>
